// Where the James Webb Space Telescope and the interstellar visitors are on
// any date, from JPL Horizons' paths (scripts/build-visitor-paths.mjs):
// public/data/jwst-path.json (geocentric ecliptic J2000, km and km a day) and
// public/data/interstellar-paths.json (heliocentric ecliptic J2000, AU and AU
// a day), read as the probes' are (src/probes/trajectory.js: cubic Hermite
// curves through position and velocity, JD in UT). Pure ESM with no DOM.

import { probeHelio } from '../probes/trajectory.js';

// Webb's geocentric position (km) at jd into out ([x, y, z]), or null before
// its launch and after the end of its prediction (1 November 2031), past
// which there is nothing to say where it is.
export function jwstGeocentric(track, jd, out) {
  const knots = track && track.knots;
  if (!knots || !knots.length || !(jd <= knots[knots.length - 1][0])) return null;
  return probeHelio(track, jd, out);
}

// An interstellar object's heliocentric position (AU) at jd into out, or null
// before its path begins (1800). After 2200 it goes on in a straight line,
// over a thousand AU out by then ('Oumuamua) where the Sun barely bends it.
export function visitorHelio(track, jd, out) {
  return probeHelio(track, jd, out);
}

const EARTH_RADIUS_KM = 6371;
const MOON_DISTANCE_KM = 384400;

// Where artistic scale puts a distance from the Earth's centre (km), in scene
// units: the Earth's drawn radius plus the height above the ground on a
// square root scaled so the Moon's mean distance lands on the Moon as drawn
// (moonRange, its distance from the Earth in scene units). Webb at L2, four
// Moon distances out, comes out about twice the Moon's distance; leaving
// the pad it rises from the drawn ground. The direction is kept.
export function jwstArtisticRange(km, earthRadius, moonRange) {
  const height = Math.max(0, km - EARTH_RADIUS_KM) / (MOON_DISTANCE_KM - EARTH_RADIUS_KM);
  return earthRadius + (moonRange - earthRadius) * Math.sqrt(height);
}
